import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Embed from "@/pages/Embed";
import AdminLogin from "@/pages/AdminLogin";
import { RequireAdmin } from "@/components/RequireAdmin";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/embed" element={<Embed />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid #D4AF37",
            color: "#FAFAFA",
          },
        }}
      />
    </div>
  );
}

export default App;
